import { Badge, Box, Text } from '@frontend/components';

type ActionBusinessNameBadgeProps = {
  businessName: string;
  isCurrent: boolean;
};

const ActionBusinessNameBadge = ({
  businessName,
  isCurrent,
}: ActionBusinessNameBadgeProps) => (
  <Box marginRight={0.5}>
    <Badge
      bg={isCurrent ? 'feature.secondary' : 'white'}
      borderColor="feature.secondary"
      size="xs"
      height={2}
      variant={isCurrent ? 'solid' : 'outline'}
    >
      <Text
        color={isCurrent ? 'white' : 'feature.secondary'}
        size="xs"
        height={2}
        textOverflow={'ellipsis'}
      >
        {businessName}
      </Text>
    </Badge>
  </Box>
);

export default ActionBusinessNameBadge;
